import React, { Component } from "react";
import firebase from "../../utils/firebase";

import { FormSection, Field, FormFooter } from "@atlaskit/form";
import FieldTextStateless from "@atlaskit/field-text";
import Button from "@atlaskit/button";

import "./profileFormReferenceAdd.css";
import FormHeader from "../../../node_modules/@atlaskit/form/dist/cjs/FormHeader";

const initState = {
  name: "",
  address: "",
  telephone: "",
  acquaintanceLength: "",
  occupation: ""
};

const initError = {
  nameError: false,
  addressError: false,
  telephoneError: false,
  acquaintanceLengthError: false,
  occupationError: false
};
export default class ProfileFormReferenceAdd extends Component {
  constructor(props) {
    super(props);

    this.state = { ...initState, ...initError };
  }

  fieldTextHandler = e =>
    this.setState({ [`${e.target.name}`]: e.target.value, ...initError });

  validate = () => {
    const {
      name,
      address,
      telephone,
      acquaintanceLength,
      occupation
    } = this.state;
    if (name.length === 0) return this.setState({ nameError: true });
    else if (address.length === 0) return this.setState({ addressError: true });
    else if (telephone.length === 0)
      return this.setState({ telephoneError: true });
    else if (acquaintanceLength.length === 0)
      return this.setState({ acquaintanceLengthError: true });
    else if (occupation.length === 0)
      return this.setState({ occupationError: true });
    else this.save();
  };

  save = () => {
    const {
      name,
      address,
      telephone,
      acquaintanceLength,
      occupation
    } = this.state;
    const referenceId = firebase
      .firestore()
      .collection("my")
      .doc().id;
    firebase
      .firestore()
      .collection("my")
      .doc(this.props.userContext.user.uid)
      .update({
        [`references.${referenceId}`]: {
          referenceId,
          name,
          address,
          telephone,
          acquaintanceLength,
          occupation
        }
      })
      .then(() => console.log("success"))
      .catch(error => console.log(error));
  };

  render() {
    console.log(this.state);
    return (
      <div className="profile-form__reference-unit">
        <FormHeader title={this.props.title} />
        <FormSection>
          <Field
            label="Reference Name"
            isRequired
            isInvalid={this.state.nameError}
          >
            <FieldTextStateless
              onChange={this.fieldTextHandler}
              value={this.state.name}
              name="name"
              isRequired
              shouldFitContainer
            />
          </Field>
          <Field
            label="Reference Address"
            isRequired
            isInvalid={this.state.addressError}
          >
            <FieldTextStateless
              onChange={this.fieldTextHandler}
              value={this.state.address}
              name="address"
              isRequired
              shouldFitContainer
            />
          </Field>
          <Field
            label="Reference Telephone"
            isRequired
            isInvalid={this.state.telephoneError}
          >
            <FieldTextStateless
              onChange={this.fieldTextHandler}
              value={this.state.telephone}
              name="telephone"
              isRequired
              shouldFitContainer
            />
          </Field>
          <Field
            label="Length of Acquaintance"
            isRequired
            isInvalid={this.state.acquaintanceLengthError}
          >
            <FieldTextStateless
              onChange={this.fieldTextHandler}
              value={this.state.acquaintanceLength}
              name="acquaintanceLength"
              isRequired
              shouldFitContainer
            />
          </Field>
          <Field
            label="Reference Occupation"
            isRequired
            isInvalid={this.state.occupationError}
          >
            <FieldTextStateless
              onChange={this.fieldTextHandler}
              value={this.state.occupation}
              name="occupation"
              isRequired
              shouldFitContainer
            />
          </Field>
        </FormSection>
        <FormFooter>
          <Button
            className="profile-form-address-add__button"
            onClick={this.validate}
            appearance="primary"
            type="submit"
          >
            Save
          </Button>
        </FormFooter>
      </div>
    );
  }
}

ProfileFormReferenceAdd.defaultProps = {
  userContext: {
    user: {},
    my: {}
  }
};



// WEBPACK FOOTER //
// ./src/components/profileFormReferenceAdd/ProfileFormReferenceAdd.js